import { z } from "zod";

import { preferenceSchema } from "../../get/schemas/get-preferences.schema";

export const putPreferencesResolverSchema = z.object({
	preferences: preferenceSchema,
});